import { curry } from 'ramda';

import { LineItemsQueryDataType } from '../../DemandRecommendationWidget.types';
import { TsrctRecommendationDecisionStatus, TsrctRecommendationsInput } from '@/generated/gql/graphql';

import { DemandRecommendationFormData, RecommendationType } from './DemandRecommendationForm.schema';

export const lineItemsToFormData = (lineItems: LineItemsQueryDataType[]): DemandRecommendationFormData => {
  return {
    demandRequestItems: lineItems.map((item) => ({
      recommendations:
        item?.recommendations?.map((recommendation) => ({
          decisionStatus: recommendation.decisionStatus,
          id: recommendation.id,
          isDirty: false,
        })) ?? [],
    })),
  };
};

export const formDataToMutationInput = (formData: DemandRecommendationFormData): TsrctRecommendationsInput[] => {
  return (
    formData.demandRequestItems
      ?.flatMap((item) => item.recommendations)
      .flatMap((recommendation) => ({ decisionStatus: recommendation?.decisionStatus, id: recommendation?.id })) ?? []
  );
};

export const getAcceptedCount = curry((isDirty: boolean, recommendations: RecommendationType[]): number => {
  return (
    recommendations?.filter(
      (recommendation) =>
        recommendation.decisionStatus === TsrctRecommendationDecisionStatus.ACCEPTED &&
        recommendation.isDirty === isDirty,
    ).length ?? 0
  );
});

export const countNonDirty = getAcceptedCount(false);

export const countDirty = getAcceptedCount(true);
